import {GlobalSearchOtherActionsPopover} from '@/components/commons/global-search/GlobalSearchOtherActionsPopover'
import {StyledCommandMenuFooter, StyledCommandMenuFooterButton} from '@/components/commons/global-search/style'
import {usePermissions} from '@/features/auth/store/store'
import {useTranslation} from '@/translations/i18n'
import {toast} from '@/utilities/toast/toast'
import {useComboboxContext} from '@ariakit/react'
import {useNavigate} from 'react-router-dom'

export const GlobalSearchFooter = ({searchValue}: {searchValue?: string}) => {
    const {t} = useTranslation()
    const comboboxContext = useComboboxContext()
    const navigate = useNavigate()
    const permissions = usePermissions()

    const handleOpenDetail = () => {
        if (!permissions?.patients.read) {
            toast.error(t('errors:no_permission_page'))
            return
        }

        const activeValue = comboboxContext?.getState()?.activeValue
        if (activeValue) {
            navigate(`/patients/${activeValue}/information`)
            comboboxContext?.hide()
        }
    }

    return (
        <StyledCommandMenuFooter>
            <StyledCommandMenuFooterButton variant="ghost" shape="rectangle" onClick={handleOpenDetail}>
                {t('global_search:open_detail')}
                <span>↵</span>
            </StyledCommandMenuFooterButton>
            <GlobalSearchOtherActionsPopover searchValue={searchValue} />
        </StyledCommandMenuFooter>
    )
}
